export default __webpack_public_path__ + "static/media/AntyLucy_7.f165b043.jpg";